export const TIME_SHEET = "timesheet";
export const TIME_OF_REQUEST = "timeOffRequest";

export const TIMESHEET_TAB_CHIPS = [
  { title: "Approved", key: "totalApprovedWH" },
  { title: "Rejected", key: "totalRejectedWH" },
  { title: "Regular", key: "regular" },
  { title: "Overtime", key: "overtime" },
  { title: "On Call", key: "on_call" },
  { title: "Holiday", key: "holiday" },
  { title: "Orientation", key: "orientation" },
];

export const TIME_SHEET_PENDING_ACTION = "pending";
export const TIME_SHEET_APPROVED_ACTION = "approved";
export const TIME_SHEET_REJECTED_ACTION = "rejected";

export const SHIFT_TYPE_DISPLAY_MAP = {
  regular: "Regular",
  on_call: "On Call",
  holiday: "Holiday",
  orientation: "Orientation",
};
